// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("DroidArabicKufi-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("DroidArabicKufi-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("DroidArabicKufi-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("DroidArabicKufi.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("DroidArabicKufi.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("DroidArabicKufi.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Droid Arabic Kufi';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Droid Arabic Kufi';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

`, "",{"version":3,"sources":["webpack://./src/assets/fonts/arabic/arabic.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC;;kEAEsD;IACtD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC;;kEAEiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Droid Arabic Kufi';\n    src: url('DroidArabicKufi-Bold.woff2') format('woff2'),\n        url('DroidArabicKufi-Bold.woff') format('woff'),\n        url('DroidArabicKufi-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Droid Arabic Kufi';\n    src: url('DroidArabicKufi.woff2') format('woff2'),\n        url('DroidArabicKufi.woff') format('woff'),\n        url('DroidArabicKufi.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
